module.exports = __webpack_public_path__ + "static/media/greco_thumb.b5969058.webp";